<template>
    <nav class="mainnav" v-bind="$attrs">
        <div class="u-flex u-flex-col">
            <nav-link
                v-for="(link, i) in links"
                :key="i"
                :to="link.to"
                :icon="link.icon"
                class="mb-12"
            >{{ link.label }}</nav-link>
        </div>
    </nav>
</template>

<script>
import NavLink from '@/components/layout/NavLink.vue'

export default {
    name: 'MainNavigation',

    components: { NavLink },

    data: () => ({
        links: [
            { label: 'Dashboard', icon: 'home', to: { name: 'Home' } },
            { label: 'Archiv', icon: 'file', to: { name: 'Documents' } },
            { label: 'Tags', icon: 'tag', to: { name: 'Tags' } },
            { label: 'Papierkorb', icon: 'trashcan', to: { name: 'Trash' } },
            { label: 'Statistik', icon: 'graph', to: { name: 'Statistics' } },
            { label: 'Einstellungen', icon: 'gear', to: { name: 'Settings' } },
        ],
    }),
}
</script>

<style lang="scss" scoped>
.mainnav {
    padding: ($head-bar-height + $spacing-unit-24) $spacing-unit-24 $spacing-unit-24;
    position: fixed;
    background: $main-navigation-background-color;
    width: $main-navigation-width-desktop;
    height: 100vh;
    box-shadow: rgba(61, 78, 102, 0.12) 1px 0 0 0;

    @include media-breakpoint-down(md) {
        padding: ($head-bar-height + $spacing-unit-12) 0 $spacing-unit-24;
        width: $main-navigation-width-mobile;
    }
}
</style>
